import { toggleChatComponent } from 'actions/Setting';
import { useEffect } from 'react';
import { connect } from 'react-redux';

function ChatComponent({ chatOpenned, toggleChatComponent }) {
    useEffect(() => {
        window.$zoho.salesiq.floatbutton.visible('show');
        return () => {
            window.$zoho.salesiq.floatbutton.visible('hide');
            window.$zoho.salesiq.floatwindow.visible('hide');
        };
    }, []);

    return null;
}
const mapStateToProps = ({ settings }) => {
    const { chatOpenned } = settings;
    return {
        chatOpenned,
    };
};

export default connect(mapStateToProps, {
    toggleChatComponent,
})(ChatComponent);
